import { z } from "zod";
import { createLocalStore, createMemoryStore } from "../../../lib/store";

// The engine the composer's mode picker dispatches the next turn to
// (docs/gpt-mode-router.md). Replaces the old source-selection preference.
// - `auto`: a fast server-side classifier picks the engine (this slice: shadow —
//   always resolves to general).
// - `general`: the streaming general chat.
// - `evidence`: the blocking graph-of-evidence engine.
// A preference (not conversation state): it survives reloads and applies to the
// next question, so it lives in localStorage. Default `auto`.
export const gptModeSchema = z.enum([
  "auto",
  "general",
  "evidence",
  "find_publication",
]);

export type GptMode = z.infer<typeof gptModeSchema>;

export const useGptMode = createLocalStore("gpt-mode", "auto", gptModeSchema);

// The mode picked on the DESKTOP landing (docs/gpt-mode-router.md, "Desktop
// shell"), with the arrival on the landing it was picked on (its history entry
// and its "New conversation" generation). Not the stored preference: every new
// desktop conversation starts in Auto, so a pick holds only for that arrival.
// Another one reads Auto again, whether or not the previous one sent anything.
export const useDesktopLandingMode = createMemoryStore<{
  locationKey: string | null;
  mode: GptMode;
}>({ locationKey: null, mode: "auto" });
